import { useState } from "react";
import { Text } from "@primer/react";
import { AlertIcon } from "@primer/octicons-react";
import { createSampleProfileDraft } from "../../domain/sampleProfile.js";
import { Button } from "../Button/Button.jsx";
import "./SampleProfileAction.css";

export function SampleProfileAction({ application, children = "Create sample profile", tone = "primary" }) {
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState(null);

  async function createSample() {
    setCreating(true);
    setError(null);
    try {
      const saved = await application.importProfile(createSampleProfileDraft(application.profiles));
      if (!saved) throw new Error("The sample profile could not be created.");
      window.location.hash = "#/compliance";
    } catch (createError) {
      setError(createError.message);
      setCreating(false);
    }
  }

  return <div className="sample-profile-action">
    <Button tone={tone} onClick={createSample} disabled={creating || application.saving || !application.applicationDocument}>{creating ? "Creating sample…" : children}</Button>
    {error ? <Text className="error" role="alert"><AlertIcon aria-hidden="true" />{error}</Text> : null}
  </div>;
}
